module.exports = __webpack_public_path__ + "img/PW.8b9e1663.png";